(function (angular) {

    'use strict';

    // Register it
    angular
        .module('app')
        .constant('payments', {
            getCreditCardType: getCreditCardType,
            litlePaypageErrorProcessor: litlePaypageErrorProcessor,
        });

    /**
    * Determines the credit card type from the credit card number.
    * @param {string} The credit card number
    * @returns {string} - Returns the credit card type.
    */
    function getCreditCardType(cardNumber) {
        return (/^5[1-5]/.test(cardNumber)) ? "mastercard"
            : (/^4/.test(cardNumber)) ? "visa"
            : (/^3[47]/.test(cardNumber)) ? 'amex'
            : (/^6011|65|64[4-9]|622(1(2[6-9]|[3-9]\d)|[2-8]\d{2}|9([01]\d|2[0-5]))/.test(cardNumber)) ? 'discover'
            : null;
    }

    function litlePaypageErrorProcessor() {
        this.litleInvalidCardCodes = [871, 872, 873, 874, 875, 876, 881, 882, 883];
        this.invalidCardMessage = "Invalid Card Number.";
        this.errorMessageToBeUsedWhenNotAnInvalidCard = "We are currently experiencing technical difficulties.  Please try again later.";
        this.generateErrorMessage = function (errorCode) {
            try {
                return errorCode && errorCode != null && this.litleInvalidCardCodes.indexOf(Number(errorCode)) > -1 ? this.invalidCardMessage : this.errorMessageToBeUsedWhenNotAnInvalidCard;
            }
            catch (error) {
                return this.errorMessageToBeUsedWhenNotAnInvalidCard;
            }
        }
    }

    
})(angular);